var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashOrderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 5.33203H5.6C5.17565 5.33203 4.76869 5.49592 4.46863 5.78764C4.16857 6.07937 4 6.47503 4 6.88759V8.44314C4.00169 8.71461 4.07641 8.98092 4.21676 9.21561C4.3571 9.4503 4.55818 9.64519 4.8 9.78092V17.7765C4.8 18.189 4.96857 18.5847 5.26863 18.8764C5.56869 19.1681 5.97565 19.332 6.4 19.332H17.6C18.0243 19.332 18.4313 19.1681 18.7314 18.8764C19.0314 18.5847 19.2 18.189 19.2 17.7765V9.78092C19.4418 9.64519 19.6429 9.4503 19.7832 9.21561C19.9236 8.98092 19.9983 8.71461 20 8.44314V6.88759C20 6.47503 19.8314 6.07937 19.5314 5.78764C19.2313 5.49592 18.8243 5.33203 18.4 5.33203ZM5.6 6.88759H18.4V8.44314H5.6V6.88759ZM6.4 17.7765V9.9987H17.6V17.7765H6.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11719 13H16.3458V15H8.11719V13Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashOrderIcon);
export default __webpack_public_path__ + "static/media/dash-order-icon.637ebcc5.svg";
export { ForwardRef as ReactComponent };